<div class="chat-widget">

  <!-- Stan: zamkniety - dwie ikonki, dzwonek nad chatem (Patryk 29.09.2026) -->
  <div class="chat-widget__launchers" *ngIf="(view$ | async) === 'closed'">
    <button
      class="chat-widget__launcher"
      mat-mini-fab
      color="primary"
      (click)="toggleNotifications()"
      [matBadge]="(badge$ | async)?.notifications || null"
      [matBadgeHidden]="!(badge$ | async)?.notifications"
      matBadgeColor="warn"
      matBadgeSize="small"
      [class.chat-widget__launcher--pulse]="hasUnackedSpecial()"
      [matTooltip]="'CHAT.NOTIFICATIONS' | translate">
      <mat-icon>notifications</mat-icon>
    </button>

    <button
      class="chat-widget__launcher"
      mat-mini-fab
      color="primary"
      (click)="toggleWidget()"
      [matBadge]="(badge$ | async)?.chats || null"
      [matBadgeHidden]="!(badge$ | async)?.chats"
      matBadgeColor="warn"
      matBadgeSize="small"
      [matTooltip]="'CHAT.TITLE' | translate">
      <mat-icon>chat</mat-icon>
    </button>
  </div>

  <!-- PANEL POWIADOMIEN - wysuwa sie bezposrednio po kliknieciu dzwonka, bez posredniej listy -->
  <div class="chat-widget__panel" *ngIf="(view$ | async) === 'notifications'">
    <div class="chat-widget__panel-header">
      <span class="chat-widget__title">{{ 'CHAT.NOTIFICATIONS' | translate }}</span>
      <button mat-icon-button (click)="closeNotifications()" [matTooltip]="'CHAT.CLOSE' | translate">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="chat-widget__ack-banner" *ngIf="unackedSpecialCount() as n">
      ⚠ {{ 'CHAT.ACK_PENDING' | translate: { n: n } }}
    </div>

    <div class="chat-widget__messages" #messagesContainer>
      <div
        class="chat-widget__notification"
        *ngFor="let n of (notifications$ | async); trackBy: trackByNotificationId"
        [class.chat-widget__notification--fresh]="isFresh(n.id)"
        [class.chat-widget__notification--pending]="n.requiresAck && !n.ackAt">
        <div class="chat-widget__notification-title">{{ n.title }}</div>
        <div class="chat-widget__notification-body">
          <ng-container *ngFor="let row of notificationRows(n)">
            <div *ngIf="row.text !== undefined">{{ row.text }}</div>
            <div *ngIf="row.id !== undefined" class="chat-widget__notification-product" (click)="goProduct(row.id, $event)">
              #{{ row.id }} · {{ row.ean }} · {{ row.name }}
            </div>
          </ng-container>
        </div>
        <div class="chat-widget__notification-footer">
          <span class="chat-widget__timestamp">{{ n.createdAt | date: 'yyyy-MM-dd HH:mm' }}</span>
          <a *ngIf="n.link" class="chat-widget__notification-link" (click)="goToLink(n.link, $event)">{{ 'CHAT.GO_TO' | translate }}</a>
          <button
            *ngIf="n.requiresAck"
            mat-icon-button
            class="chat-widget__ack-button"
            [class.chat-widget__ack-button--done]="!!n.ackAt"
            [disabled]="!!n.ackAt"
            (click)="acknowledgeNotification(n, $event)"
            [matTooltip]="(n.ackAt ? 'CHAT.ACKNOWLEDGED' : 'CHAT.ACKNOWLEDGE') | translate">
            <mat-icon>thumb_up</mat-icon>
          </button>
        </div>
      </div>

      <div class="chat-widget__empty" *ngIf="(notifications$ | async)?.length === 0">
        {{ 'CHAT.NO_NOTIFICATIONS' | translate }}
      </div>
    </div>
  </div>

  <!-- PANEL CZATOW: lista rozmow z ludzmi + otwarta konkretna rozmowa -->
  <div class="chat-widget__panel" *ngIf="(view$ | async) === 'list' || (view$ | async) === 'conversation'">

    <!-- LISTA CZATOW -->
    <ng-container *ngIf="(view$ | async) === 'list'">
      <div class="chat-widget__panel-header">
        <button mat-button (click)="openNewConversationDialog()" [matTooltip]="'CHAT.NEW_CONVERSATION' | translate">
          <mat-icon>add_comment</mat-icon>{{ 'CHAT.OPEN_CHAT' | translate }}
        </button>
        <button mat-button (click)="collapseToClosed()" [matTooltip]="'CHAT.CLOSE_WINDOW' | translate">
          <mat-icon>close</mat-icon>{{ 'CHAT.CLOSE_WINDOW' | translate }}
        </button>
      </div>

      <div class="chat-widget__list">
        <button type="button" class="chat-widget__list-item" *ngFor="let c of (conversations$ | async); trackBy: trackByConversationId" (click)="selectConversation(c.id)">
          <span class="chat-widget__icon" [ngClass]="'chat-widget__icon--' + iconKind(c)" [class.chat-widget__icon--active]="c.unreadCount > 0">
            <mat-icon>{{ iconKind(c) === 'group' ? 'groups' : 'person' }}</mat-icon>
          </span>
          <span class="chat-widget__list-item-body">
            <span class="chat-widget__list-item-name">{{ c.name }}</span>
            <span class="chat-widget__list-item-preview" *ngIf="c.lastMessage as lm">
              {{ lm.deleted ? ('CHAT.MESSAGE_DELETED' | translate) : lm.body }}
            </span>
          </span>
          <span class="chat-widget__unread-count" *ngIf="c.unreadCount > 0">{{ c.unreadCount }}</span>
        </button>

        <div class="chat-widget__empty" *ngIf="(conversations$ | async)?.length === 0">
          {{ 'CHAT.NO_CONVERSATIONS' | translate }}
        </div>
      </div>

      <div class="chat-widget__inactive-toggle">
        <mat-checkbox [ngModel]="showInactive$ | async" (ngModelChange)="toggleShowInactive()">
          {{ 'CHAT.SHOW_INACTIVE_CONVERSATIONS' | translate }}
        </mat-checkbox>
      </div>
    </ng-container>

    <!-- OTWARTY, KONKRETNY CZAT -->
    <ng-container *ngIf="(view$ | async) === 'conversation'">
      <div class="chat-widget__panel-header">
        <button mat-button (click)="closeConversation()" [matTooltip]="'CHAT.BACK_TO_LIST' | translate">
          <mat-icon>list</mat-icon>{{ 'CHAT.BACK_TO_LIST' | translate }}
        </button>
        <button mat-button (click)="collapseToClosed()" [matTooltip]="'CHAT.CLOSE_WINDOW' | translate">
          <mat-icon>close</mat-icon>{{ 'CHAT.CLOSE_WINDOW' | translate }}
        </button>
      </div>

      <div class="chat-widget__conversation-actions" *ngIf="activeConversation() as ac">
          <button mat-button *ngIf="ac.isGroup" (click)="openAddParticipantDialog(ac)">
            <mat-icon>person_add</mat-icon>{{ 'CHAT.ADD_PARTICIPANT' | translate }}
          </button>
        </div>

        <div class="chat-widget__messages" #messagesContainer>
          <div
            class="chat-widget__message"
            *ngFor="let m of (messages$ | async); trackBy: trackByMessageId"
            [class.chat-widget__message--own]="m.authorId === myProfilId"
            [class.chat-widget__message--fresh]="isFresh(m.id) && m.authorId !== myProfilId">
            <div class="chat-widget__message-author" *ngIf="activeConversation()?.isGroup && authorLabel(activeConversation(), m.authorId) as author">
              {{ author }}
            </div>

            <ng-container *ngIf="editingMessageId === m.id; else plainBody">
              <div class="chat-widget__edit-box">
                <input matInput [(ngModel)]="editingDraft" (keydown.enter)="saveEdit()" maxlength="4000">
                <button mat-icon-button (click)="saveEdit()"><mat-icon>check</mat-icon></button>
                <button mat-icon-button (click)="cancelEdit()"><mat-icon>close</mat-icon></button>
              </div>
            </ng-container>
            <ng-template #plainBody>
              <div class="chat-widget__message-body" [class.chat-widget__message-body--deleted]="m.deleted">
                {{ m.deleted ? ('CHAT.MESSAGE_DELETED' | translate) : m.body }}
              </div>
            </ng-template>

            <div class="chat-widget__message-footer">
              <span class="chat-widget__timestamp">
                {{ m.createdAt | date: 'HH:mm' }}<span *ngIf="m.editedAt"> · {{ 'CHAT.EDITED' | translate }}</span>
              </span>
              <ng-container *ngIf="!m.deleted && m.authorId === myProfilId && editingMessageId !== m.id">
                <button mat-icon-button *ngIf="m.editable" (click)="startEdit(m)" [matTooltip]="'COMMON.EDIT' | translate">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button *ngIf="m.deletable" (click)="deleteMessage(m)" [matTooltip]="'COMMON.DELETE' | translate">
                  <mat-icon>delete</mat-icon>
                </button>
              </ng-container>
            </div>
          </div>

          <div class="chat-widget__empty" *ngIf="(messages$ | async)?.length === 0">
            {{ 'CHAT.NO_MESSAGES' | translate }}
          </div>
        </div>

        <div class="chat-widget__composer">
          <input matInput [(ngModel)]="draft" (keydown.enter)="sendMessage()" [placeholder]="'CHAT.WRITE_MESSAGE' | translate" maxlength="4000">
          <button mat-icon-button color="primary" [disabled]="!draft.trim()" (click)="sendMessage()">
            <mat-icon>send</mat-icon>
          </button>
        </div>
    </ng-container>
  </div>
</div>
